import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

export interface InputSemanticStyles {
  background: string;
  backgroundHover: string;
  backgroundSelected: string;

  backgroundFiltered: string;
  backgroundFilteredHover: string;

  backgroundError: string;
  backgroundErrorHover: string;

  backgroundDisabled: string;

  inverseBackground: string;
  inverseBackgroundHover: string;
}

export const lightInputSemanticStyles = {
  background: colorPrimitive.alpha.black.black100,
  backgroundHover: colorPrimitive.alpha.black.black200,
  backgroundSelected: colorPrimitive.alpha.black.black300,

  backgroundFiltered: colorPrimitive.blue[200],
  backgroundFilteredHover: colorPrimitive.blue[300],

  backgroundError: colorPrimitive.red[200],
  backgroundErrorHover: colorPrimitive.red[300],

  backgroundDisabled: colorPrimitive.alpha.transparent,

  inverseBackground: colorPrimitive.alpha.white.white500,
  inverseBackgroundHover: colorPrimitive.alpha.white.white2000,
} as const satisfies InputSemanticStyles;

export const redesignedLightInputSemanticStyles = {
  ...lightInputSemanticStyles,

  backgroundFiltered: colorPrimitive.blurple[200],
  backgroundFilteredHover: colorPrimitive.blurple[300],
} as const satisfies InputSemanticStyles;

export const darkInputSemanticStyles = {
  background: colorPrimitive.alpha.white.white200,
  backgroundHover: colorPrimitive.alpha.white.white300,
  backgroundSelected: colorPrimitive.alpha.white.white300,

  backgroundFiltered: colorPrimitive.blue[900],
  backgroundFilteredHover: colorPrimitive.blue[800],

  backgroundError: colorPrimitive.red[900],
  backgroundErrorHover: colorPrimitive.red[800],

  backgroundDisabled: colorPrimitive.alpha.transparent,

  inverseBackground: colorPrimitive.alpha.white.white100,
  inverseBackgroundHover: colorPrimitive.alpha.white.white200,
} as const satisfies InputSemanticStyles;

export const redesignedDarkInputSemanticStyles = {
  ...darkInputSemanticStyles,
  backgroundFiltered: colorPrimitive.blurple[900],
  backgroundFilteredHover: colorPrimitive.blurple[800],
} as const satisfies InputSemanticStyles;
